module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-normal.b0bc5c44.png";